import { ComponentProps } from "react";

import { Tabs } from "domains/inbox/components/Tabs";

export const ConversationTabItem = ({
    ...props
}: ComponentProps<typeof Tabs.Link.Item>) => {
    return <Tabs.Link.Item {...props} />;
};
